import * as React from 'react';
import { imgPath } from '../../../../common/utils/ImgUrl';
import { Workbook } from '../../../models/SearchResultTypes';
import { CardViewStyles } from '../CardViewStyles';
import { ContentCard, getContentUrlForItem } from '../ContentCard';
import { classNames } from '../../../../../homepage/Utils';
import { Thumbnail } from '../Thumbnail';
import { Messages } from '../../../../../gen-src/Localize';
import { CommonStyles } from '../../../../common/styles/CommonStyles';
import { WorkbookTooltip } from '../tooltips/WorkbookTooltip';
import { EntityLink, UserEntityLink } from '../../tooltips/elements/EntityLink';
import { SessionManagementService } from '../../../services/SessionManagementService';
import { ConnectedFavoriteToggle } from '../../Favorites/FavoriteToggle';
import { FeatureFlag, FeatureFlagService } from '../../../services/FeatureFlagService';

export const ViewDefaultImageUrl = imgPath('spaces_card_workbook.svg');

export const WorkbookCardNameTestID = 'WorkbookCardName';
export const WorkbookCardSubSectionTestID = 'WorkbookCardSubSection';
export const WorkbookCardTestID = 'WorkbookCard';

export class WorkbookCard extends ContentCard {
  public render() {
    const workbookInfo = this.props.content as Workbook;
    const isOwner = SessionManagementService.instance.sessionUserId() === workbookInfo.owner?.id;
    const locationLink = this.getLinkForLocationType(this.props.urls, isOwner, workbookInfo.location);

    return (
      <div className={classNames(CardViewStyles.Card)} data-tb-test-id={WorkbookCardTestID}>
        <Thumbnail
          navigateUrl={getContentUrlForItem(workbookInfo)}
          defaultImageUrl={ViewDefaultImageUrl}
          thumbnailImageUrl={workbookInfo.thumbnailUrl}
          decorate={true}
          ariaLabel={workbookInfo.name}
          onResultItemSelected={this.props.onResultItemSelected}
        />

        <div className={CardViewStyles.ActionRow} style={{ marginTop: CommonStyles.Spacing.LargeSpace }}>
          <span data-tb-test-id={WorkbookCardNameTestID} className={CardViewStyles.ActionRowName} title={workbookInfo.name}>
            {workbookInfo.name}
          </span>
          {FeatureFlagService.instance.getValue(FeatureFlag.offspringPostMVP224) ? (
            <span style={{ position: 'relative', bottom: '2px' }}>
              <ConnectedFavoriteToggle searchResultItem={workbookInfo} />
            </span>
          ) : null}
          {this.renderInfoIconAndPopover(() => (
            <WorkbookTooltip content={workbookInfo} urls={this.props.urls} />
          ))}
        </div>
        <div data-tb-test-id={WorkbookCardSubSectionTestID}>
          {workbookInfo.owner && (
            <div className={CardViewStyles.SubSection}>
              {Messages.OwnerSubTitle()}{' '}
              <b>
                <UserEntityLink
                  name={workbookInfo.owner.displayName}
                  href={this.props.urls.userContentUrl(workbookInfo.owner.username, workbookInfo.owner.domainName)}
                  styleOverride={CardViewStyles.Links}
                />
              </b>
            </div>
          )}

          {workbookInfo.location?.type ? (
            locationLink.url ? (
              <div className={CardViewStyles.SubSection}>
                {Messages.LocationSubTitle()}{' '}
                <b>{<EntityLink name={locationLink.text} href={locationLink.url} styleOverride={CardViewStyles.Links} />}</b>
              </div>
            ) : (
              <div className={CardViewStyles.SubSection}>
                {Messages.LocationSubTitle()} <b>{locationLink.text}</b>
              </div>
            )
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }
}
